import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { apiUrls } from '../../../config/api/api-urls.config';
import { MatchsResultsResponse } from '../../../models/matchs/responses/api-matchs-results-response.model';
import { MatchsCcuResultsResponse } from '../../../models/matchs/responses/api-matchs-ccu-response.model';
import { MatchsCreditBalanceResultsResponse } from '../../../models/matchs/responses/api-matchs-credit-balance-response.model';

@Injectable({
  providedIn: 'root'
})
export class ApiMatchsService {

  constructor(private apiService: ApiService) { }

  getMatchsTables(page: number, resultCount: number): Promise<MatchsResultsResponse> {
    return new Promise<MatchsResultsResponse>((resolve, reject) => {
      const body = { page, result_count: resultCount };
      this.apiService.launchAdminApiRequestPost(apiUrls.matchsGetMatchsTablesUrl, body, MatchsResultsResponse).then(
        (data: MatchsResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }

  addMatchTable(
    name: string,
    levelMinimumRequired: number,
    levelExperienceRewardQuantity: number,
    leaguePointRewardQuantity: number,
    hammerRewardQuantity: number,
    creditRewardQuantity1: number,
    creditRewardQuantity2: number,
    creditRewardQuantityDraw: number,
    matchCost: number,
    matchRank: number,
    variantId: number
  ): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const body = {
        name,
        level_minimum_required: levelMinimumRequired,
        level_experience_reward_quantity: levelExperienceRewardQuantity,
        league_point_reward_quantity: leaguePointRewardQuantity,
        hammer_reward_quantity: hammerRewardQuantity,
        credit_reward_quantity_1: creditRewardQuantity1,
        credit_reward_quantity_2: creditRewardQuantity2,
        credit_reward_quantity_draw: creditRewardQuantityDraw,
        match_cost: matchCost,
        match_rank: matchRank,
        variant_id: variantId
      };
      this.apiService.launchAdminApiRequestPost(apiUrls.matchsAddMatchTableUrl, body).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  editMatchTable(
    matchTableId: number,
    name: string,
    levelMinimumRequired: number,
    levelExperienceRewardQuantity: number,
    leaguePointRewardQuantity: number,
    leaguePointRewardQuantity2: number,
    hammerRewardQuantity: number,
    creditRewardQuantity1: number,
    creditRewardQuantity2: number,
    creditRewardQuantityDraw: number,
    matchCost: number,
    matchRank: number,
    variantId: number
  ): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const body = {
        match_table_id: matchTableId,
        name,
        level_minimum_required: levelMinimumRequired,
        level_experience_reward_quantity: levelExperienceRewardQuantity,
        league_point_reward_quantity: leaguePointRewardQuantity,
        league_point_reward_quantity_2: leaguePointRewardQuantity2,
        hammer_reward_quantity: hammerRewardQuantity,
        credit_reward_quantity_1: creditRewardQuantity1,
        credit_reward_quantity_2: creditRewardQuantity2,
        credit_reward_quantity_draw: creditRewardQuantityDraw,
        match_cost: matchCost,
        match_rank: matchRank,
        variant_id: variantId
      };
      this.apiService.launchAdminApiRequestPost(apiUrls.matchsEditMatchTableUrl, body).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  deleteMatchTable(matchTableId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.matchsDeleteMatchTableUrl, { match_table_id: matchTableId }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  getMatchsCcu(): Promise<MatchsCcuResultsResponse> {
    return new Promise<MatchsCcuResultsResponse>((resolve, reject) => {
      this.apiService.launchAdminApiRequestGet(apiUrls.matchsGetMatchsCcuUrl, MatchsCcuResultsResponse).then(
        (data: MatchsCcuResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }

  getMatchsCreditBalance(): Promise<MatchsCreditBalanceResultsResponse> {
    return new Promise<MatchsCreditBalanceResultsResponse>((resolve, reject) => {
      this.apiService.launchAdminApiRequestGet(apiUrls.matchsGetMatchsCreditBalanceUrl, MatchsCreditBalanceResultsResponse).then(
        (data: MatchsCreditBalanceResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }
}
